export default "__VITE_ASSET__CNbc4lpM__"